module.exports = __webpack_public_path__ + "img/solico.6e6ec2d.png";